import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import CustomEase from "gsap/CustomEase";

gsap.registerPlugin(ScrollTrigger, CustomEase);

export default function () {
    const customEaseBack = CustomEase.create("custom", "M0,0 C0,0 0.063,0.026 0.1,0.2 0.121,0.301 0.174,0.506 0.2,0.6 0.219,0.672 0.26,0.784 0.285,0.838 0.318,0.91 0.358,0.944 0.385,0.971 0.408,0.994 0.455,1.028 0.48,1.041 0.506,1.054 0.552,1.068 0.59,1.069 0.683,1.074 1,1 1,1 ");

    /**
     * Section Free Ski
     */
    (() => {
        const section = {
            image: {x: '50%', y: '50%'},
            video: {x: '-50%', y: '25%'},
            mobile: {title: {y: '-60%'}},
            smUp: {title: {y: '-30%'}},
            mdUp: {title: {y: '-10%'}},
            lgUp: {title: {y: '-5%'}}
        }

        const freeSkiTl = (obj) => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: ".section-free-ski",
                    start: '70% bottom',
                    toggleActions: 'play reset restart reverse',
                    markers: false
                }
            })

            tl.to('.section-free-ski__title', {
                y: obj.title.y,
                duration: 2.5,
                opacity: 1,
                ease: 'power4.out',
            }).to('.section-free-ski__image', {
                rotate: '-15deg',
                x: section.image.x,
                y: section.image.y,
                duration: 2,
                ease: customEaseBack,
            }, '<').to('.section-free-ski__video', {
                rotate: '15deg',
                x: section.video.x,
                y: section.video.y,
                duration: 2,
                ease: customEaseBack,
            }, '<')

            return tl
        }

        const mm = gsap.matchMedia()

        mm.add(
            {
                mobile: '(max-width: 576px)',
                smUp: '(min-width: 576px)',
                mdUp: '(min-width: 768px)',
                lgUp: '(min-width: 992px)',
            },
            (context) => {
                const {smUp, mdUp, lgUp} = context.conditions;

                let target = 'mobile'
                if (smUp) target = 'smUp'
                if (mdUp) target = 'mdUp'
                if (lgUp) target = 'lgUp'

                freeSkiTl(section[target])

                return () => freeSkiTl(section.mobile)
            }
        )
    })();

    /**
     * Section Animated Video
     */
    (() => {
        const section = '.section-animated-video'

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                pin: false,
                start: 'bottom bottom',
                end: '+=1000',
                scrub: 1,
                markers: false,
            },
        })

        tl.to(section, {
            css: {
                '--clip-path': '0',
            },
        },).to(section, {
            css: {
                '--video-height': '100%',
            },
        }, '>-=0.2')

        gsap.to(section, {
            css: {
                '--overlay-height': 0,
            },
            duration: 1,
            ease: "steps(7)",
            scrollTrigger: {
                trigger: section,
                start: '90% bottom',
                toggleActions: 'play none none reverse',
                markers: false
            }
        })
    })();

    /**
     * Section Grid Videos
     */
    (() => {
        const sectionContainer = '.section-grid-videos-container'
        const section = '.section-grid-videos'

        const sectionParams = {
            mobile: {
                itemWidth: '100px',
                itemHeight: '450px',
                y: '-70%'
            },
            mdUp: {
                itemWidth: '425px',
                itemHeight: '460px',
                y: '-70%'
            },
            xlUp: {
                itemWidth: '25vw',
                itemHeight: '27vw',
                y: '-70%'
            },
        }

        const gridVideosTl = (obj) => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: sectionContainer,
                    pin: true,
                    start: 'bottom bottom',
                    end: '+=3000',
                    scrub: 3,
                    markers: false,
                },
            })

            tl.from('.grid-video-content', {
                opacity: 0,
                y: '100%',
                duration: 2
            }).to(section, {
                css: {
                    '--item-width': obj.itemWidth,
                    '--item-height': obj.itemHeight,
                    '--gap': '10px',
                    '--rounded': '1rem',
                },
                duration: 3
            }, '<').to(section, {
                css: {
                    '--y': obj.y
                },
                duration: 1.5
            }, ">-=1")

            return tl
        }

        const mm = gsap.matchMedia()

        mm.add(
            {
                mobile: '(max-width: 576px)',
                mdUp: '(min-width: 768px)',
                xlUp: '(min-width: 1400px)',
            },
            (context) => {
                const {mdUp, xlUp} = context.conditions;

                let target = 'mobile'
                if (mdUp) target = 'mdUp'
                if (xlUp) target = 'xlUp'

                gridVideosTl(sectionParams[target])

                return () => gridVideosTl(sectionParams.mobile)
            }
        )
    })();

    /**
     * Section Athletes
     */
    (() => {
        const section = '.section-athlete'

        gsap.to('.section-athlete__bg .container', {
            css: {
                '--rounded': 0,
                '--padding': '0rem',
                maxWidth: '100%'
            },
            scrollTrigger: {
                trigger: section,
                start: '50% bottom',
                end: 'top',
                scrub: 1,
                markers: false
            }
        });
    })();
}
